var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeySkillIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5C1 3.11438 1 2.17157 1.58579 1.58579C2.17157 1 3.11438 1 5 1H27C28.8856 1 29.8284 1 30.4142 1.58579C31 2.17157 31 3.11438 31 5V27C31 28.8856 31 29.8284 30.4142 30.4142C29.8284 31 28.8856 31 27 31H5C3.11438 31 2.17157 31 1.58579 30.4142C1 29.8284 1 28.8856 1 27V5Z",
    fill: "#7E869E",
    fillOpacity: 0.25,
    stroke: "#141F37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3335 11L18.6227 19.5662C18.1968 20.2051 17.2396 20.1455 16.8962 19.4587L15.1041 15.8746C14.7607 15.1878 13.8036 15.1282 13.3776 15.7671L7.66683 24.3333",
    stroke: "#141F37",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeySkillIcon3);
export default __webpack_public_path__ + "static/media/key-skill-icon-3.2483539a7cdbe449885afaf4ab99adb5.svg";
export { ForwardRef as ReactComponent };